import * as React from "react";

import { cn } from "@/lib/utils";

export interface CodeTextProps extends React.ComponentProps<"span"> {
  tone?: "default" | "muted";
  numeric?: boolean;
}

export function CodeText({ className, tone = "muted", numeric = false, ...props }: CodeTextProps) {
  return (
    <span
      className={cn(
        "font-mono text-xs",
        tone === "muted" ? "text-muted-foreground" : "text-foreground",
        numeric ? "tabular-nums" : null,
        className,
      )}
      {...props}
    />
  );
}
